import { useField } from 'formik';

import { ProductMessage } from '../../../../types/ProductMessage';
import { ProductOption, ProductSelect, ProductSelectProps } from '../ProductSelect/ProductSelect';

export interface FormikProductSelectProps extends Omit<ProductSelectProps, 'onChange' | 'value'> {
    name: string;
    onSelect?: (product: ProductMessage) => void;
    forceNegative?: boolean;
}

export const FormikProductSelect = ({ onSelect, forceNegative = false, ...props }: FormikProductSelectProps) => {
    const [field, meta, helpers] = useField(props.name);

    const onChange = (option: ProductOption | null) => {
        if (!option) {
            helpers.setValue('');
            return;
        }
        helpers.setValue(option.value);
        onSelect?.(option.product);
    };

    return (
        <ProductSelect
            {...props}
            onBlur={() => {
                helpers.setTouched(true, true);
            }}
            negative={forceNegative || (meta.touched && !!meta.error)}
            value={field.value}
            onChange={onChange}
        />
    );
};
